app.controller("CopyProgramController", [
    "$scope", "StaticData", "ProgramService", "$uibModalInstance", "params",
    function ($scope, StaticData, ProgramService, $uibModalInstance, params) {
        $scope.code = params.program.code+ "1";
        $scope.migration = false;

        $scope.changeLevel = function () {
            $scope.credits = $scope.level.credits;
            $scope.semesters = $scope.level.semesters;
        };

        $scope.copyProgram = function () {
            var parameters = {
                programId:params.program._id,
                code: $scope.code,
                migration: $scope.migration
            };
            ProgramService.copyProgram(parameters).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);